module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "menu-tab-container",
    attrs: {
      "show": _vm.isShow
    }
  }, [_c('div', {
    staticClass: "menu-container"
  }, [_c('div', {
    staticClass: "arrow-wrap"
  }), _vm._v(" "), _c('div', {
    staticClass: "menu-item first",
    on: {
      "click": function($event) {
        return _vm.menuAction('index')
      }
    }
  }, [_c('div', {
    staticClass: "item-icon"
  }, [_c('img', {
    attrs: {
      "src": _vm.image.index,
      "alt": ""
    }
  })]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "menu-item second",
    on: {
      "click": function($event) {
        return _vm.menuAction('category')
      }
    }
  }, [_c('div', {
    staticClass: "item-icon"
  }, [_c('img', {
    attrs: {
      "src": _vm.image.category,
      "alt": ""
    }
  })]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "menu-item third",
    on: {
      "click": function($event) {
        return _vm.menuAction('my')
      }
    }
  }, [_c('div', {
    staticClass: "item-icon"
  }, [_c('img', {
    attrs: {
      "src": _vm.image.my,
      "alt": ""
    }
  })]), _vm._v(" "), _vm._m(2)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-text"
  }, [_c('span', [_vm._v("首页")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-text"
  }, [_c('span', [_vm._v("选购")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-text last"
  }, [_c('span', [_vm._v("我的")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ce7bba2"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./static/components/menu-tab/components/tab.vue
// module id = 287
// module chunks = 1 2 5 6 15 19 27 28